import { createRouter, createWebHistory } from 'vue-router';
import Home from '../components/PageHome.vue';
import About from '../components/PageAbout.vue';
import NotFound from '../components/PageNotFound.vue';

const routes = [
  { path: '/', component: Home },
  { path: '/about', component: About },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
]

export default createRouter({
  history: createWebHistory(),
  routes
});
